module.exports = __webpack_public_path__ + "img/tmf.de2ac35d.png";